import { TrashIcon } from "@/components/_icons/trashIcon";

export interface RemoveFromCartButtonProps {
  // eslint-disable-next-line no-unused-vars
  removeFromCart: (event: React.MouseEvent, index: number) => void;
  // eslint-disable-next-line no-unused-vars
  index: number;
}

export const RemoveFromCartButton = ({
  removeFromCart,
  index,
}: RemoveFromCartButtonProps) => {
  return (
    <button
      onClick={(event: React.MouseEvent) => removeFromCart(event, index)}
      className="mt-2"
    >
      <TrashIcon />
    </button>
  );
};
